import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MessagingService {

  constructor(private http: HttpClient) { }

  getEvents(): Observable<any> {
    const url = `${environment.apiOrigin}/api/message-templates/events/converge`;
    return this.http.get(url);
  }

  saveMessageTemplate(messageTemplate: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/message-templates`;
    if (messageTemplate.id == null) {
      return this.http.put(url, messageTemplate);
    } else {
      return this.http.post(url, messageTemplate);
    }
  }

  getMessageTemplate(id: string): Observable<any> {
    const url = `${environment.apiOrigin}/api/message-templates/${id}`;
    return this.http.get(url);
  }

  getMessageTemplates(): Observable<any> {
    const url = `${environment.apiOrigin}/api/message-templates`;
    return this.http.get(url);
  }
}
